import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTheme } from "../context/ThemeContext";
import { selectUserId, selectUserRoles } from "../redux/users/userSelectors";
import "../globals.css";

const Header = () => {
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const userId = useSelector(selectUserId);
  const roles = useSelector(selectUserRoles);
  const user = { id: userId, roles: roles || [] };

  const handleLogout = useCallback(() => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/sign-in");
  }, [navigate]);

  const handleGoBack = useCallback(() => {
    navigate("/product-finder");
  }, [navigate]);

  return (
    <header
      className={`sticky top-0 z-10 w-full bg-black text-white transition-colors duration-300 ${
        theme === "dark" ? "dark:bg-gray-800 dark:text-white" : ""
      }`}
    >
      <div className="max-w-full flex items-center justify-between py-2 px-8">
        <div className="flex items-center">
          <img
            src="https://www.regent.ch/fileadmin/main/images/logo_white.svg"
            alt="logo"
            width={150}
            height={50}
            onClick={handleGoBack}
            className="object-contain cursor-pointer"
          />
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-6">
          <div title="Profile" className="mx-3 btnProfile mt-0">
            <span className="hidden">My profile</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={32}
              height={32}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
              focusable="false"
            >
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20c0-4 4-7 8-7s8 3 8 7" />
            </svg>
          </div>

          {/* Dashboard Icon */}
          {user.id &&
            user.roles.some((r: { name: string }) => r.name !== "User") && (
              <a
                href="https://regent-lighting.co.in/backend/dashboard"
                target="_blank"
                rel="noopener noreferrer"
                title="Dashboard"
                className="flex items-center justify-center mx-2 glyphicon glyphicon-th"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={30}
                  height={30}
                  viewBox="0 0 24 24"
                  fill="white"
                >
                  <path d="M4 4h4v4H4V4zm6 0h4v4h-4V4zm6 0h4v4h-4V4zM4 10h4v4H4v-4zm6 0h4v4h-4v-4zm6 0h4v4h-4v-4zM4 16h4v4H4v-4zm6 0h4v4h-4v-4zm6 0h4v4h-4v-4z" />
                </svg>
              </a>
            )}

          {/* Logout Icon */}
          <button className="" title="Logout" onClick={handleLogout}>
            <svg
              stroke="currentColor"
              fill="none"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
              aria-hidden="true"
              className="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
              />
            </svg>
          </button>

          {/* Theme Toggle Icon */}
          <button className="" onClick={toggleTheme}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={`w-7 h-7 ${
                theme === "dark" ? "text-white" : "text-black"
              }`}
            >
              <circle cx="12" cy="12" r="10" />
            </svg>
          </button>

          {/* Search Icon */}
          <button className="" title="Search">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6 text-white"
            >
              <circle cx="11" cy="11" r="8" />
              <line
                x1="21"
                y1="21"
                x2="16.65"
                y2="16.65"
                stroke="white"
                strokeWidth="2"
              />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
